// src/tour/components/tourTheme.js
// Casavio design system tokens used by the tour UI (master context §57).
export const TC = {
  bubbleBg: '#FDFAF6',
  bubbleBorder: '#DDD4C6',
  primary: '#B8721F',     // amber
  primaryHover: '#D4902A',
  dotInactive: '#DDD4C6',
  dotActive: '#B8721F',
  backdrop: 'rgba(44, 29, 20, 0.65)',
  body: '#2C1D14',        // brown
  muted: '#9A7B68',
  bg: '#F2EDE4',
  successBg: '#EBF5EF',
  success: '#2E6B4A',
  fHead: 'Georgia, serif',
  fBody: 'Calibri, sans-serif',
}

// Minimum 44px touch targets.
export const touchBtn = {
  minHeight: 44,
  padding: '11px 18px',
  borderRadius: 10,
  fontSize: 15,
  cursor: 'pointer',
  fontFamily: TC.fBody,
}
